import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { forms as Forms, pills as Pills } from '@breezeway/brzw-components';
import './form_control_multiselect.scss';

const getPillElementName = (options, element) =>
  _.get(_.find(options, { value: element }), 'label', element);

class FormControlMultiselect extends PureComponent {
  constructor(props) {
    super(props);

    this.onRemovePills = this.onRemovePills.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(option) {
    const {
      input: { onChange, value },
      selectValue,
    } = this.props;

    const { created } = option;
    const code = option.value;
    const name = created ? option.value : option.label;

    if (selectValue) {
      onChange([...value, code]);
    } else {
      onChange([...value, { code, name }]);
    }
  }

  onRemovePills(index) {
    const {
      input: { onChange, value },
    } = this.props;

    return () => onChange([..._.slice(value, 0, index), ..._.slice(value, index + 1)]);
  }

  render() {
    const {
      className,
      creatable,
      creatableText,
      id,
      input: { value },
      label,
      meta: { touched, error },
      options,
      placeholder,
      required,
      searchable,
      selectValue,
      shouldShowTextError,
    } = this.props;

    let selectedValues = [];
    if (selectValue) {
      selectedValues = _.isArray(value) ? value : [];
    } else {
      selectedValues = _.map(value, option => option.code);
    }
    const withError = touched && !_.isEmpty(error);

    return (
      <div key={`multivalue-select-${id}`}>
        <Forms.Select
          className={className}
          creatable={creatable}
          creatableText={creatableText}
          hiddenValues={selectedValues}
          id={id}
          isRequired={required}
          labelText={label}
          onSelect={this.onSelect}
          options={options}
          placeholderText={placeholder}
          searchable={searchable}
          value=""
          withError={error}
        />
        <div className="multiselect__pills-wrapper">
          {_.map(value, (element, index) => {
            const pillName = getPillElementName(options, element);
            return (
              <div
                className="multiselect__pill-wrapper"
                key={`additional-element-wrapper-${index}`}
              >
                <Pills.Pill
                  key={`multiselect-element-${index}`}
                  onClick={this.onRemovePills(index)}
                  text={selectValue ? pillName : element.name}
                />
              </div>
            );
          })}
        </div>

        {shouldShowTextError && withError && <span className="multiselect__error">{error}</span>}
      </div>
    );
  }
}

FormControlMultiselect.propTypes = {
  className: PropTypes.string,
  creatable: PropTypes.bool,
  creatableText: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  selectValue: PropTypes.bool,
  shouldShowTextError: PropTypes.bool,
};

FormControlMultiselect.defaultProps = {
  className: '',
  creatable: false,
  options: [],
  searchable: false,
  selectValue: false,
};

export default FormControlMultiselect;
